import {
  Box,
  Checkbox,
  CheckboxGroup,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  HStack,
  Icon,
  RadioGroup,
  Stack,
  Text,
  Tooltip,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Field } from "formik";
import { RadioButtonField } from "../../../../../components/RadioButtonField";
import { CustomMultiSelectWField } from "../../../../../components/MultiSelect";
import { CustomInputWField } from "../../../../../components/CustomInputWField";
import { onlyNumbers } from "../../../../../utils/masks";
import { PopoverGenero } from "../../../../../components/PopoverGenero";
import { useCallback, useState } from "react";
import CargaSelecaoService from "../../../../../../main/services/CargaSelecaoService";
import { IoHelpCircle } from "react-icons/io5";

export const PerfilAtendimentoAba = ({ children, props, isMobile }) => {
  const [generos, setGeneros] = useState({ options: [], isLoading: false });
  const placement = useBreakpointValue({ md: "right" });
  const [isOpen, setIsOpen] = useState(false);
  const [hintTodos, setHintTodos] = useState(false);
  const [hintAtende, setHintAtende] = useState(false);
  const [hintAnos, setHintAnos] = useState(false);
  const [hintFaixa, setHintFaixa] = useState(false);

  const handleGetGeneros = useCallback(() => {
    setGeneros((prevState) => ({ ...prevState, isLoading: true }));
    CargaSelecaoService.getGeneros().then((res) => {
      res.data.push({
        id: 8,
        genero: "OUTROS",
        descricao: "Descrição do gênero Outros",
      });
      const tempOptions = res.data.map((genero) => {
        return {
          id: genero.id,
          descricao: genero.descricao,
          genero: genero.genero,
          label: (
            <HStack justifyContent="space-between">
              <Text
                color="#1A203D"
                fontWeight={400}
                fontSize={{ base: "12px", md: "14px" }}
              >
                {genero.genero}
              </Text>

              <Tooltip
                label={genero.descricao}
                fontSize="md"
                textAlign={"justify"}
                width="90%"
              >
                <span className="hint-tooltip">
                  <Icon
                    aria-label="Aviso de pendente"
                    color="#6B6C71"
                    as={IoHelpCircle}
                    boxSize="20px"
                  />
                </span>
              </Tooltip>
            </HStack>
          ),
        };
      });
      setGeneros({ options: tempOptions, isLoading: false });
    });
  }, []);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const renderizarTooltip = (texto, isOpenTooltip, setIsOpenTooltip) => {
    if (isMobile) {
      return (
        <PopoverGenero
          isOpen={isOpenTooltip}
          setIsOpen={setIsOpenTooltip}
          flex={true}
          handleClick={() => setIsOpenTooltip(!isOpenTooltip)}
          labelTextoGenero={texto}
        />
      );
    }

    return (
      <Tooltip
        label={texto}
        fontSize="md"
        maxW="400px"
        textAlign="justify"
        placement={placement}
      >
        <span className="hint-tooltip" style={{ zIndex: 0 }}>
          <Icon
            aria-label="Aviso de pendente"
            color="#6B6C71"
            as={IoHelpCircle}
            boxSize="20px"
          />
        </span>
      </Tooltip>
    );
  };

  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Perfil de Atendimento
        </Text>
        {children}
      </Flex>

      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Gênero
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Box>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioGenero">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioGenero && form.touched.radioGenero
                  }
                  id="radioGenero"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioGenero", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-genero-sr"
                        fieldName="radioGenero"
                        value="SR"
                        label="Sem Restrição"
                      />
                      <RadioButtonField
                        id="radio-genero-as"
                        fieldName="radioGenero"
                        value="AS"
                        label="Atende Somente"
                      />
                      <RadioButtonField
                        id="radio-genero-na"
                        fieldName="radioGenero"
                        value="NA"
                        label="Não Atende"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioGenero}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
          <GridItem colSpan={{ base: 15, xl: 7, "2xl": 5 }} zIndex={"3"}>
            <Flex alignItems={props.errors.idGenero ? "center" : "end"} gap={2}>
              <CustomMultiSelectWField
                fieldName="idGenero"
                label="Gênero"
                placeholder="Selecione o Gênero"
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.id}
                isLoading={generos.isLoading}
                options={generos.options}
                isDisabled={
                  (props?.values?.radioGenero &&
                    props?.values?.radioGenero === "SR") ||
                  !props?.values?.radioGenero
                }
                onChange={(value) => {
                  props.setFieldValue("idGenero", value);
                }}
                values={props?.values?.idGenero[0] || ""}
                onFocus={
                  generos?.options?.length === 0 ? handleGetGeneros : null
                }
                visible
                todos
              />

              {props.values.idGenero && isMobile && (
                <PopoverGenero
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  handleClick={handleClick}
                  labelTextoGenero={
                    props.values?.idGenero?.label?.props?.children[1]?.props
                      ?.label
                  }
                />
              )}
            </Flex>
          </GridItem>
        </Grid>
      </Box>
      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Faixa Etária
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Box mt={7}>
        <Grid templateColumns="repeat(12, 1fr)" gap="15px" mt="15px" w="100%">
          <GridItem colSpan={{ base: 9, xl: 6, "2xl": 4 }}>
            <Field name="radioFaixaEtaria">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioFaixaEtaria &&
                    form.touched.radioFaixaEtaria
                  }
                  id="radioFaixaEtaria"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioFaixaEtaria", value)
                    }
                  >
                    <Stack direction="column" gap={4}>
                      <Flex gap={3} alignItems="center">
                        <RadioButtonField
                          fieldName="radioFaixaEtaria"
                          value="TO"
                          label="Todos"
                        />
                        {renderizarTooltip(
                          "A pesquisa apresentará como resultado, serviços de acolhimento sem restrição de faixa etária e com restrição de faixa etária.",
                          hintTodos,
                          setHintTodos,
                        )}
                      </Flex>
                      <Flex gap={3} alignItems="center">
                        <RadioButtonField
                          id="radio-faixa-sr"
                          fieldName="radioFaixaEtaria"
                          value="AT"
                          label="Atende"
                        />
                        {renderizarTooltip(
                          "A pesquisa apresentará como resultado, serviços de acolhimento que aceitam crianças e adolescentes que estejam dentro da faixa etária pesquisada.",
                          hintAtende,
                          setHintAtende,
                        )}
                      </Flex>
                      <Flex gap={4} alignItems="flex-start">
                        <Text pt="17px">
                          De{props.values.radioFaixaEtaria === "AT" ? "*" : " "}
                        </Text>

                        <GridItem colSpan={{ base: 9, xl: 2 }} maxW="120px">
                          <CustomInputWField
                            fieldName="idadeInicial"
                            placeholder="00"
                            maxLength={4}
                            isDisabled={
                              !(
                                props?.values?.radioFaixaEtaria &&
                                props?.values?.radioFaixaEtaria === "AT"
                              )
                            }
                            onChange={(e) =>
                              props.setFieldValue(
                                "idadeInicial",
                                onlyNumbers(e.target.value),
                              )
                            }
                          />
                        </GridItem>

                        <Text pt="17px">
                          até{" "}
                          {props.values.radioFaixaEtaria === "AT" ? "*" : " "}
                        </Text>

                        <GridItem colSpan={{ base: 9, xl: 2 }} maxW="120px">
                          <CustomInputWField
                            fieldName="idadeFinal"
                            placeholder="00"
                            maxLength={4}
                            isDisabled={
                              !(
                                props?.values?.radioFaixaEtaria &&
                                props?.values?.radioFaixaEtaria === "AT"
                              )
                            }
                            onChange={(e) =>
                              props.setFieldValue(
                                "idadeFinal",
                                onlyNumbers(e.target.value),
                              )
                            }
                          />
                        </GridItem>

                        <Flex pt="17px" gap={3} alignItems="center">
                          <Text>anos</Text>

                          {renderizarTooltip(
                            "A pesquisa apresentará como resultado, serviços de acolhimento que aceitam crianças e adolescentes que estejam dentro da faixa etária pesquisada.",
                            hintAnos,
                            setHintAnos,
                          )}
                        </Flex>
                      </Flex>

                      <Flex gap={3} alignItems="center">
                        <RadioButtonField
                          id="radio-faixa-cr"
                          fieldName="radioFaixaEtaria"
                          value="CR"
                          label="Com Restrição de Faixa Etária"
                        />
                        {renderizarTooltip(
                          "A pesquisa apresentará como resultado, serviços de acolhimento que possuem restrição no atendimento considerando exatamente a idade mínima aceita e idade máxima aceita informadas.",
                          hintFaixa,
                          setHintFaixa,
                        )}
                      </Flex>

                      <Flex gap={4} alignItems="flex-start">
                        <GridItem colSpan={{ base: 9, xl: 2 }}>
                          <CustomInputWField
                            fieldName="idadeMinima"
                            label={`Idade Mínima Aceita pelo Serviço ${props.values.radioFaixaEtaria === "CR" ? "*" : " "}`}
                            placeholder="00"
                            maxLength={3}
                            isDisabled={
                              !(
                                props?.values?.radioFaixaEtaria &&
                                props?.values?.radioFaixaEtaria === "CR"
                              )
                            }
                            onChange={(e) =>
                              props.setFieldValue(
                                "idadeMinima",
                                onlyNumbers(e.target.value),
                              )
                            }
                          />
                        </GridItem>
                        <GridItem colSpan={{ base: 9, xl: 2 }}>
                          <CustomInputWField
                            fieldName="idadeMaxima"
                            label={`Idade Máxima Aceita pelo Serviço ${props.values.radioFaixaEtaria === "CR" ? "*" : " "}`}
                            placeholder="00"
                            maxLength={3}
                            isDisabled={
                              !(
                                props?.values?.radioFaixaEtaria &&
                                props?.values?.radioFaixaEtaria === "CR"
                              )
                            }
                            onChange={(e) =>
                              props.setFieldValue(
                                "idadeMaxima",
                                onlyNumbers(e.target.value),
                              )
                            }
                          />
                        </GridItem>
                      </Flex>
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioFaixaEtaria}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Saúde
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Faz Restrição de Criança/Adolescente com Deficiência?"}
          mb={2}
        >
          Faz Restrição de Criança/Adolescente com Deficiência?
        </Text>

        <Field name="radioSaudeCriancaDeficiencia">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.radioSaudeCriancaDeficiencia &&
                form.touched.radioSaudeCriancaDeficiencia
              }
              id="radioSaudeCriancaDeficiencia"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("radioSaudeCriancaDeficiencia", value)
                }
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox id="checkbox-deficiencia-sim" value="S">
                    Sim
                  </Checkbox>

                  <Checkbox id="checkbox-deficiencia-nao" value="N">
                    Não
                  </Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.radioSaudeCriancaDeficiencia}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={
            "Faz Restrição de Criança/Adolescente que Faz Uso de Substâncias Psicoativas?"
          }
          mb={4}
        >
          Faz Restrição de Criança/Adolescente que faz uso de Substâncias
          Psicoativas?
        </Text>
        <Field name="radioSaudeSubstanciasPsicoativas">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.radioSaudeSubstanciasPsicoativas &&
                form.touched.radioSaudeSubstanciasPsicoativas
              }
              id="radioSaudeSubstanciasPsicoativas"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("radioSaudeSubstanciasPsicoativas", value)
                }
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox id="checkbox-substancias-sim" value="S">
                    Sim
                  </Checkbox>

                  <Checkbox id="checkbox-substancias-nao" value="N">
                    Não
                  </Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.radioSaudeSubstanciasPsicoativas}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={
            "Faz Restrição de Criança/Adolescente que Demanda Cuidados de Saúde?"
          }
          mb={4}
        >
          Faz Restrição de Criança/Adolescente que Demanda Cuidados de Saúde?
        </Text>
        <Field name="radioSaudeCriancaCuidados">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.radioSaudeCriancaCuidados &&
                form.touched.radioSaudeCriancaCuidados
              }
              id="radioSaudeCriancaCuidados"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("radioSaudeCriancaCuidados", value)
                }
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox id="checkbox-cuidados-sim" value="S">
                    Sim
                  </Checkbox>

                  <Checkbox id="checkbox-cuidados-nao" value="N">
                    Não
                  </Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.radioSaudeCriancaCuidados}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
    </>
  );
};
